import { render, staticRenderFns } from "./TermsEdit.vue?vue&type=template&id=2fd57cc6&"
import script from "./TermsEdit.vue?vue&type=script&lang=ts&"
export * from "./TermsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports